import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { removeKey, storeSelected, syncSelected, useFormSaveStore, useTabTitle } from '../../utils'
import { LotProvider } from './LotContext'
import { LotEditModal } from './LotEditModal'
import { LotView } from './LotView'
import { LotStationType, LotType } from './lot-types'
import { useGetLotList, useGetOccupancyByLotId, useGetStationByParkingLot } from './utils/lot-hooks'
import { useOccupancyConfig } from '../Occupancy/hooks/useOccupancyConfig'
import { browserHistory } from '../../App'

export const LotContainer = () => {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    let lot = queryParams.get('lot')
    const history = useHistory()
    const storedSelectedLot = syncSelected('selectedLot')
    if (!lot) {
        if (storedSelectedLot) {
            history.push(`?lot=${storedSelectedLot}`)
            lot = storedSelectedLot
        }
    } else {
        if (storedSelectedLot && storedSelectedLot !== lot) {
            storeSelected('selectedLot', lot)
        }
    }
    const [editingStation, setEditingStation] = useState<LotStationType | null | undefined>(null)

    const [selectedLot, setSelectedLot] = useState<LotType | null | undefined>()
    const {
        data: lotStations,
        refetch: refetchLotStations,
        loading: loadingLotStations
    } = useGetStationByParkingLot(selectedLot ? selectedLot.id + '_1' : undefined)
    useTabTitle(selectedLot, (lot) => lot?.id || 'Parking Lot')
    const {
        data: occupancyValue,
        refetch: refetchOccupancyValue,
        lastFetchOccupancy
    } = useGetOccupancyByLotId(selectedLot?.id)
    useEffect(() => {
        const lotStationToSetAsCurrenteditingStation = lotStations?.station.find(
            (station) => station.station_name === editingStation?.station_name
        )
        setEditingStation(lotStationToSetAsCurrenteditingStation)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lotStations])
    const { data: lots, loading: loadingLots } = useGetLotList()
    const setSelectedStationHandler = (lot: LotType | null | undefined): void => {
        const { hasChanges, resetChanges } = useFormSaveStore.getState()

        if (hasChanges) {
            const confirmed = window.confirm('You have unsaved changes. Are you sure you want to switch devices?')
            if (!confirmed) return
            const unblock = browserHistory.block(true)

            setTimeout(() => unblock(), 0)
            resetChanges()
        }
        if (lot) {
            storeSelected('selectedLot', lot.id)
            history.push(`?lot=${lot?.id}`)
        } else {
            removeKey('selectedLot')
            history.push(`/lot`)
        }
        setSelectedLot(lot)
    }
    const {
        occupancyConfig,
        setOccupancyConfig,
        onHandleSubmit,
        loading: occupancyLoading,
        saving: occupancySaving
    } = useOccupancyConfig(selectedLot?.id)

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search)
        const lotId = queryParams.get('lot')

        if (lotId && lots?.lot) {
            const matchedLot = lots.lot.find((l) => l.id === lotId)
            if (matchedLot && matchedLot.id !== selectedLot?.id) {
                setSelectedLot(matchedLot)
            }
        }
    }, [location.search, lots, selectedLot])

    useEffect(() => {
        if (!selectedLot || !lots?.lot) return

        const matchedLot = lots.lot.find((l) => l.id === selectedLot.id)
        if (matchedLot && matchedLot.size !== selectedLot.size) {
            setSelectedLot(matchedLot)
        }
    }, [lots, selectedLot])
    // const { getAuthenticationData, isAuthenticated } = useAuth0()
    // const [userId, setUserId] = useState<string | null>(null)
    // const occupancyTestUsers = [
    //     'ariunbaatar.ganbaatar@wemolo.com',
    //     'haixiang.zhang@wemolo.com',
    //     'philipp.fritz@wemolo.com'
    // ].includes(userId ?? '')
    // useEffect(() => {
    //     const fetchUserId = async () => {
    //         try {
    //             const tokenKey = Object.keys(localStorage).find((key) => key.startsWith('@@auth0spajs@@'))
    //             const raw = tokenKey && localStorage.getItem(tokenKey)
    //             const parsed = raw ? JSON.parse(raw) : null
    //             const localId = parsed?.body?.decodedToken?.claims?.email
    //             if (localId) {
    //                 setUserId(localId)
    //                 return
    //             }
    //             const authData = await getAuthenticationData()
    //             const authId = authData?.claims?.email
    //             if (authId) {
    //                 setUserId(authId)
    //             }
    //         } catch (err) {
    //             // silently fail
    //         }
    //     }

    //     fetchUserId()
    // }, [getAuthenticationData, isAuthenticated])

    return (
        <LotProvider
            context={{
                lots,
                setEditingStation,
                selectedLot,
                setSelectedLot: setSelectedStationHandler,
                lotStations,
                editingStation,
                occupancyConfig,
                setOccupancyConfig,
                onHandleSubmit,
                loading: occupancyLoading,
                saving: occupancySaving,
                loadingLots,
                loadingLotStations,
                occupancyValue,
                lastFetchOccupancy,
                fetchOccupancyValue: () => {
                    if (selectedLot?.id) {
                        refetchOccupancyValue()
                    }
                },
                refetchLotStations
                // occupancyTestUsers
            }}
        >
            <LotView />
            {editingStation && <LotEditModal refetch={() => refetchLotStations()} />}
        </LotProvider>
    )
}
